import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setErrorMessage, setIsLoading, setIsToasterError } from "./app";
import API from "../../api/api";

// export interface IBescheideBody {
//   username: string;
//   userSurname?: string;
//   phoneNumber: string;
//   contactPhoneNumber: string;
//   email: string;
//   idNumber: string;
//   street: string;
//   homeNumber: string;
//   homeNumberZusatz?: string;
//   postCode: string;
//   place: string;
//   country?: string;
//   iban: string;
//   bic: string;
//   payerType?: string | undefined;
// // }
// BescheidId: 37503,
//     BelegId: 50877,
//     BelegDatum: '2025-02-25T00:00:00',
//     AbrechnungDatumVon: '2025-01-01T00:00:00',
//     AbrechnungDatumBis: '2025-12-31T23:59:59',
//     Belegart: 'Jahresbescheid',
//     GesamtbetragVorausleistung: 189,
//     GesamtbetragIst: 197.28,
//     Dokument:
//Kassenzeichen: '14617059',
// StornoJN:
export interface IBescheideResponseBody {
  // id: string;
  // createdAt: string;
  // status: string;
  BescheidId: string;
  BelegId: string;
  BelegDatum: string;
  AbrechnungDatumVon: string;
  AbrechnungDatumBis: string;
  Belegart: string;
  GesamtbetragVorausleistung: string;
  GesamtbetragIst: string;
  Dokument: string;
  Kassenzeichen: string;
  StornoJN: boolean;
}

interface IBescheide {
  user: {
    data: IBescheideResponseBody[];
    isBescheideDataLoading: boolean;
  };
}

const initialState: IBescheide = {
  user: {
    data: [],
    isBescheideDataLoading: false,
  },
};

export const getBescheideData = createAsyncThunk(
  "bescheide/user/getBescheideData",
  async (
    {
      belegDatumBis,
      belegDatumVon,
      objektId,
      signal,
    }: {
      objektId: string;
      belegDatumVon?: Date | null;
      belegDatumBis?: Date | null;
      signal?: AbortSignal;
    },
    { dispatch }
  ) => {
    try {
      dispatch(setIsLoading(true));

      const data = await API.bescheide.get.getBescheideData({
        belegDatumBis,
        belegDatumVon,
        objektId,
        signal,
      });

      return data;
    } catch (error: any) {
      if (error !== "Request canceled") {
        dispatch(setIsToasterError(true));
        dispatch(setErrorMessage(error?.response?.data?.message));
      }
    } finally {
      dispatch(setIsLoading(false));
    }
  }
);

const bescheideSlice = createSlice({
  name: "bescheide",
  initialState,
  reducers: {
    clearAdminBescheideData: (state) => {
      state.user.data = [];
      state.user.isBescheideDataLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBescheideData.pending, (state) => {
      state.user.isBescheideDataLoading = true;
    });
    builder.addCase(getBescheideData.fulfilled, (state, action) => {
      if (action.payload) {
        state.user.data = [...action.payload];
      }
      state.user.isBescheideDataLoading = false;
    });
    builder.addCase(getBescheideData.rejected, (state) => {
      state.user.isBescheideDataLoading = false;
    });
  },
});

export const { clearAdminBescheideData } = bescheideSlice.actions;

export const bescheideReducer = bescheideSlice.reducer;
